import { PauseCircle } from "lucide-react";

// Branded, platform-controlled page for sites whose hosting is inactive
// (public API returned `paused: true` / `paused_reason: "hosting_required"`).
// Never exposes billing details, Stripe info, or internal account state.
// Reactivation is automatic — once hosting is active the normal site renders.
export default function PausedSite() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FFFDF0] px-6" data-testid="public-paused-site">
      <div className="nb-card p-10 text-center max-w-md">
        <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-amber-50 border-2 border-amber-200 flex items-center justify-center">
          <PauseCircle className="w-7 h-7 text-amber-500" />
        </div>
        <div className="font-display text-2xl font-extrabold text-slate-900" data-testid="paused-site-title">
          This website is temporarily unavailable
        </div>
        <p className="text-sm text-slate-600 mt-3" data-testid="paused-site-detail">
          Hosting for this website is currently inactive.
        </p>
        <p className="text-xs text-slate-400 mt-6">Powered by Interest To Income</p>
      </div>
    </div>
  );
}
